import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule } from '@ngx-translate/core';
import { GenericInputHintModule } from '../../generic-input-hint/generic-input-hint.module';
import { GenericInputSlotModule } from '../../generic-input-slot/generic-input-slot.module';
import { GenericTextareaInputComponent } from './generic-textarea-input.component';

export * from './generic-textarea-input.component';

@NgModule({
    declarations: [ GenericTextareaInputComponent ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        TranslateModule,
        GenericInputHintModule,
        MatInputModule,
        GenericInputSlotModule,
        MatButtonModule,
        MatIconModule,
    ],
    exports: [
        GenericTextareaInputComponent,
    ],
})
export class GenericTextareaInputModule {
}
